/**
 *  Firebase libraries for browser - npm package.
 *
 * Usage:
 *
 *   firebase = require('firebase');
 */
require('./firebase');
module.exports = firebase;



//////////////////
// WEBPACK FOOTER
// ../redux-firebase-sync/~/firebase/firebase-browser.js
// module id = 62
// module chunks = 0